// extracted by mini-css-extract-plugin
export var arrow = "_kx-1";
export var content = "_kx-0";
export var highlighted = "_kx-2";